import React from "react";
import "./features.css";
import featuresData from "./data.json";


const FeatureBox = (item) => {
    return (
        <div className={`feature-item ${item.index%2 === 1 ? 'rightImage' : ''}`}>
            <div className="item-image subsection">
                <img src={item.imagePath} />
            </div>
            <div className="subsection item-content">
                <div className="item-heading">{item.title}</div>
                <div className="item-data">
                {item.description.map((item, index) => {
                  return (
                    <li key={index}>{item}</li>
                  );
                })}
                <br></br>
                {item.links.map((item, index) => {
                  return (
                    <div>
                    <div key={index} className="button"><a href={item.url} style={{backgroundColor: item.color}} target="_blank" className="button-open-position" >{item.text} <i class="fa fa-external-link" aria-hidden="true"></i></a></div>
                    </div>
                  );
                })}
                </div>
            </div>
        </div>
    );
};

const Features = () => {
  return (
    <div className="features" id="features">
      {/* <div className="features-heading">Features &amp; Benefits</div> */}
      <div className="infobox-list section-1">
        {featuresData.map((item, index) => {
          return (
            <FeatureBox
                key={index}
                index={index}
                {...item}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Features;